// import React, { Component } from "react";
import React,{useState} from "react"
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TradingViewWidget from 'react-tradingview-widget';
import Select from '@material-ui/core/Select';
import DenseTable from "./PageParts/TableSmartTrade";




// import TradingViewWidget, { Themes } from 'react-tradingview-widget';

import avatar from "assets/img/faces/marc.jpg";
import { ButtonGroup, FormControl, Grid, Input, InputAdornment, InputBase, Menu, MenuItem, TextField, Tooltip, Typography } from "@material-ui/core";
import { card } from "assets/jss/material-dashboard-react";

// My Component 
import Switch from '@material-ui/core/Switch';
import ToogleThings from "./PageParts/ToogleThings";
import CustomTabs from "components/CustomTabs/CustomTabs";
import { BusinessCenterTwoTone, ContactSupport, CreditCard, DateRange, ImportExport, LayersClear, Refresh, Search, Visibility } from "@material-ui/icons";
import Loading from "./PageParts/Loading";
import Tasks from "components/Tasks/Tasks";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButtonsPrecent from "./PageParts/ToggleButtonPrecentSmall";
import ToggleButton from '@material-ui/lab/ToggleButton';
import Slider from "./PageParts/Slider";
import ToggleButtons from "./PageParts/ToggleButtons";
import ToggleButtonPrecent from "./PageParts/ToggleButtonPrecent";
import ToggleButtonPrecentSmall from "./PageParts/ToggleButtonPrecentSmall"
import ToggleButtonSmall from "./PageParts/ToggleButtonSmall"
import CustomizedSlider from "./PageParts/Slider"
import cardBodyStyle from "assets/jss/material-dashboard-react/components/cardBodyStyle";
import SearchBox from "./PageParts/SearchBox";
import DatePicker from "./PageParts/Calender";
import { ButtonDropdown } from "reactstrap";
import TextButtons from "./PageParts/SMenu";
import SMenu from "./PageParts/SMenu";
import LoadingOverlay from 'react-loading-overlay';
import SortableTable from "./PageParts/Sortabletable";
import DataTable from "./PageParts/Sortabletable";
import EnhancedTable from "./PageParts/Sortabletable";






const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};




// const options = [
//   {
//       label: <span>Foo</span>,
//       value: {
//            foo: true
//       },
//       selectedBackgroundColor: "#0097e6",
//   },
//   {
//       label: "Bar",
//       value: "bar",
//       selectedBackgroundColor: "#fbc531"
//   }
// ];

// const onChange = (newValue) => {
//    console.log(newValue);
// };

// const initialSelectedIndex = options.findIndex(({value}) => value === "bar");

// return (
//    <div className="your-required-wrapper" style={{width: 100, height: 30}}>
//        <SwitchSelector
//            onChange={onChange}
//            options={options}
//            initialSelectedIndex={initialSelectedIndex}
//            backgroundColor={"#353b48"}
//            fontColor={"#f5f6fa"}
//        />
//    </div>
// );

// const App = () => (
//   <TradingViewWidget symbol="NASDAQ:AAPL" />
// );



// class ShowHideParts extends Component{
//   constructor(){
//     super()
//     this.state={
//       showMe:true
//     }
//   }
//   operation()
//   {
//     alert("Heeeeey")
//     this.setState({
//       ShowMe:!this.state.ShowMe
//     })
//   }

//   render(){
//     return(
//       <div>
//         {
//           this.state.showMe?
//           <div>
//             please hide
//           </div>
//           :null
//         }
//         <Button onClick={()=>this.operation()}>Click Here</Button>
//       </div>
//     )
//   }
// }



const ShowHideSomthing = ()=>{

  const[show,setShow]=useState(false)
    return(
      
    <div className="ShowHideSomthing">
      
      <Switch color="primary" onClick={()=>setShow(!show)}>Show</Switch>
      {
        show?<div>asdsad</div>
        :null
      }
    </div>
    
  );  
}

const TradingView = () => (
  <TradingViewWidget
  // width= "980"
  // height= "610"
  autosize="true"
  symbol= "NASDAQ:AAPL"
  interval= "D"
  timezone= "Etc/UTC"
  theme= "light"
  style= "1"
  locale= "en"
  toolbar_bg= "#f1f3f6"
  // enable_publishing= "false"
  withdateranges= "true"
  hide_side_toolbar= "false"
  allow_symbol_change= "true"
  details= "true"
  hotlist= "false"
  container_id= "tradingview_5cb26"
  />
);
                                        // Smart Trade Page

const useStyles = makeStyles(styles);


export default function UserProfile() {
  
                                                  // Buttons Group Codes
  const ToggleButtonThreeB=()=> {
    const [alignment, setAlignment] = React.useState('left');
  
    const handleAlignment = (event, newAlignment) => {
      setAlignment(newAlignment);
    };
  
    return (
      <ToggleButtonGroup
        value={alignment}
        exclusive
        onChange={handleAlignment}
        aria-label="text alignment"
      >
        
  
        
            <ToggleButton style={{width:"110px"}} value="left">
              Limit
            </ToggleButton>
            <ToggleButton style={{width:"110px"}} value="center">
              Market
            </ToggleButton>
            <ToggleButton onClick={ToggleCondComponent} style={{width:"110px"}} value="right">
              Cond
            </ToggleButton>
            
          </ToggleButtonGroup>
    );
  }
                                          // Show/Hide Things Start //

                                          // Trading View 
  const [TradingViewComponent,ToggleThingsComponent] = ToogleThings(
    <GridContainer xs={12} sm={12} md={12} style={{padding:"10px", height:"600px"}}>
    <GridItem xs={12} sm={12} md={10}><TradingView/></GridItem></GridContainer>
  ,false);
                                          // Signals
  const [SignalComponent,ToggleSignalComponent] = ToogleThings(
    <Card>
      <CardBody>
        <DenseTable/>
      </CardBody>
    </Card>
  ,false);

  const [CondComponent,ToggleCondComponent] = ToogleThings(
    <GridItem style={{textAlign:"center"}}>
      <ToggleButtonSmall/>
    </GridItem>
  ,false);
                                            // Trade Terminal

const [TradeTerminalComponent,ToggleTradeTerminalComponent] = ToogleThings();  



                                              // Orders & Positions


const [OrdersDataComponent,ToggleOrdersDataComponent] = ToogleThings(
  <GridItem  md={12} sm={12} xs={12}> 

    <GridContainer id="orderspositionsbox">
    <GridItem md={3} sm={3} xs={3}>
      <SearchBox></SearchBox> 
    </GridItem>

    <GridItem md={3} sm={3} xs={3}>
      <Tooltip placement="top"
      title="Refresh"
      arrow> 
      <Button style={{background:"#12daf2", width:"60px"}}><a style={{color:"white"}} href="#"><Refresh style={{height:"22px",width:"40px"}}/></a></Button>
      </Tooltip>
    </GridItem>
    </GridContainer>


    <GridContainer style={{paddingBottom:"-10px", }}>

      <EnhancedTable/>

      
      {/* <GridItem >
        <p>Stop Loss Timeout</p>
      </GridItem>

      <GridItem style={{marginLeft:"-30px"}}>
        <Tooltip placement="top" 
            title="A double check before triggering the Stop Loss. The system will check conditions when the price reaches them, 
            and additionally after the set amount of seconds passes.
              If Stop Loss condition is not true after the delay, it won’t trigger. 
              A high delay might incur higher losses  " 
              arrow >
          <ContactSupport style={{ width:"20px"}}/>
        </Tooltip>  
      </GridItem>

      <GridItem id="tabboxswitch">
        <Switch/>
      </GridItem> */}

    </GridContainer>


  </GridItem>

,false); 

const [OrdersComponent,ToggleOrdersComponent] = ToogleThings(
<GridItem id="ordersandpositions" md={12} sm={12} xs={12}>
                    
      <GridItem  md={12} sm={12} xs={12}> 
            
            <CardHeader style={{marginLeft:"-19px"}} color="primary" stats>
              
              <h4>You have no open orders</h4>

              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                <Switch onClick={ToggleOrdersDataComponent}/>
              </GridItem>
            </CardHeader>

            {OrdersDataComponent}
        

      </GridItem>
      </GridItem>
,false); 
                                              
                                              
                                          // History Tab in Foooter
const [HistoryComponent,ToggleHistoryComponent] = ToogleThings(
<GridItem  md={12} sm={12} xs={12}> 

  <GridContainer id="orderspositionsbox">

    <GridItem md={3} sm={12} xs={12}>
      <GridItem id="filterstextonbox">
        <p>Created on</p>
      </GridItem>
      <GridContainer style={{}}>

        <GridItem style={{width:"88px", height:"50px"}}>
        
          <FormControl style={{}} variant="outlined" >
            <InputLabel style={{}} id="demo-simple-select-outlined-label"></InputLabel>
              <Select style={{marginBottom:"20px", width:"88px",height:"38px", fontSize:"12px"}}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                // value={age}
                // onChange={handleChange}
                label="Age"
              >
                <MenuItem value="">
                  {/* <em>Date Range</em> */}
                </MenuItem >
                <MenuItem  value={10}>From</MenuItem>
                <MenuItem value={20}>To</MenuItem>
                {/* <MenuItem value={30}>Thirty</MenuItem> */}
              </Select>
            </FormControl>
          
        </GridItem>

        <GridItem style={{ position: 'relative', zIndex: '100' }}>
          {/* <TextField style={{width:"180px",height:"50px"}} variant="outlined"></TextField> */}
          <DatePicker/>
        </GridItem>


        {/* <GridItem id="">
          <Switch/>
        </GridItem> */}

      </GridContainer>
      
    </GridItem>

    <GridItem md={3} sm={12} xs={12}>
    <GridItem id="filterstextonbox">
        <p>Closed on</p>
      </GridItem>
      <GridContainer style={{}}>

        <GridItem style={{width:"88px", height:"50px"}}>

          <FormControl style={{}} variant="outlined" >
            <InputLabel style={{marginTop:"-6px"}} id="demo-simple-select-outlined-label"></InputLabel>
              <Select style={{marginBottom:"20px", width:"88px",height:"38px", fontSize:"12px"}}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                // value={age}
                // onChange={handleChange}
                label="Age"
              >
                <MenuItem value="">
                  {/* <em>Date Range</em> */}
                </MenuItem >
                <MenuItem  value={10}>From</MenuItem>
                <MenuItem value={20}>To</MenuItem>
                {/* <MenuItem value={30}>Thirty</MenuItem> */}
              </Select>
            </FormControl>
          
        </GridItem>

        <GridItem style={{ position: 'relative', zIndex: '100' }}>
          {/* <TextField style={{width:"180px",height:"50px"}} variant="outlined"></TextField> */}
          <DatePicker />
        </GridItem>


        {/* <GridItem id="">
          <Switch/>
        </GridItem> */}

      </GridContainer>
    </GridItem>

    <GridItem md={3} sm={12} xs={12}>
    <GridItem id="filterstextonbox">
        <p>Account</p>
      </GridItem>
      <TextField id="filterstextfield" variant="outlined"></TextField> 
    </GridItem>

    <GridItem md={3} sm={12} xs={12}>
    <GridItem id="filterstextonbox">
        <p>Pair</p>
      </GridItem>
      <TextField id="filterstextfield" variant="outlined"></TextField> 
    </GridItem>


    <GridContainer md={12} >
    
       <GridContainer id="filterbuttonsposition"> 
       <GridItem >
         <Button id="filtersbuttons"><Visibility/>Show Canceled</Button>   
       </GridItem>

       <GridItem>
         <Button id="filtersbuttons"><Visibility/>Show Finished</Button>   
       </GridItem> 

       <GridItem>
         <Button id="filtersbuttons"><Visibility/>Show Failed</Button>   
       </GridItem> 

       <GridItem>
         <Button id="filtersbuttons"><Visibility/>SimpleTrade</Button>   
       </GridItem> 
        
       <GridItem>
         <Button id="filtersbuttons"><ImportExport/> Export</Button>   
       </GridItem>  

       </GridContainer>
    </GridContainer>
  </GridContainer>

  <LoadingOverlay
  
  active={false}
  spinner
  text='Loading your content...'
  >
  <GridContainer md={12} sm={12} xs={12}>
      <GridItem style={{textAlign:"center", height:"200px"}} md={12} sm={12} xs={12}>
        <p>No data to display</p>
        
      </GridItem>
  </GridContainer>
  </LoadingOverlay>

</GridItem>

,false);

                                          //  Ends Here //


  
  const classes = useStyles();
  return (
    <div>
      
        <GridContainer md={12} style={{backgroundColor:"#00acc1",borderRadius:"10px",}}>
            <GridItem xs={6} sm={6} md={6} >
            <p>2 days left in your trial period.</p>
            </GridItem>
            
            <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                  <Button style={{border:"1px solid white"}} type="button" color="info">Buy Subscription</Button>
            </GridItem>
            
        </GridContainer>
        
        <GridContainer md={12}>

          

          <GridItem md={1} >    
              
              <p id="smarttradetopswiches">TradingView</p>
              
          </GridItem>

          <GridItem md={1} >

              <Switch onClick={ToggleThingsComponent} id="tradingswich"></Switch>
              
          </GridItem>

          <GridItem md={1} >    
              
              <p id="smarttradetopswiches">Signals</p>
              
          </GridItem>

          <GridItem md={1} >

              <Switch  onClick={ToggleSignalComponent} id="tradingswich"></Switch>
              
          </GridItem>

          {/* <GridItem md={1} >    
              
              <p id="smarttradetopswiches">Trade terminal</p>
              
          </GridItem>
          <GridItem md={1} >

              <ShowHideSomthing/>
              
          </GridItem> */}

          <GridItem md={2} >    
              
              <p id="smarttradetopswiches">Orders and positions</p>
              
          </GridItem>
          <GridItem md={1} >

              <Switch onClick={ToggleOrdersComponent}/>
              
          </GridItem>
          
          
             
        </GridContainer>


      <GridContainer>

                                      {/* Select Options Part */}
      <GridContainer style={{background:"white", marginLeft:"10px"}} md={12}>
      
        <GridItem md={4}>
          <p style={{marginBottom:"1px"}}>Exchange</p>
          <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">Demo</InputLabel>
            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              // value={age}
              // onChange={handleChange}
              label="Age"
            >
              <MenuItem value="">
                <em>Demo</em>
              </MenuItem>
              {/* <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem> */}
            </Select>
          </FormControl>

        </GridItem>

        <GridItem md={4}>
        <p style={{marginBottom:"1px"}}>Market</p>
        <FormControl  variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">USDT</InputLabel>
            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              // value={age}
              // onChange={handleChange}
              label="Market"
            >
              <MenuItem value="">
                <em>asd</em>
              </MenuItem>
              <MenuItem value={10}>BTC</MenuItem>
              <MenuItem value={20}>ETH</MenuItem>
              <MenuItem value={30}>GBP</MenuItem>
            </Select>
          </FormControl>
        </GridItem>

        <GridItem md={4}>
        <p style={{marginBottom:"1px"}}>Trading Pair</p>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel  id="demo-simple-select-outlined-label">Trading Pair</InputLabel>
            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              // value={age}
              // onChange={handleChange}
              label="Age"
            >
              <MenuItem value="">
                <em>Trading Pair</em>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </FormControl>
        </GridItem>

      </GridContainer>
                                          {/* Signal Part */}

          {SignalComponent}
                                       {/* Trading View Part */}
        

            {TradingViewComponent}
          
           {/* 
          <GridItem id="tradingviewsidebox">
            <CardBody style={{ background:"white"}}>
              <Typography>asdad</Typography>
            </CardBody>
          </GridItem> */}

        

                                      {/* Trading Terminal Section */}

        <GridContainer md={12}> 
          <GridItem xs={12} sm={12} md={12} style={{marginBottom:"-2.3rem",}}>
            <CustomTabs
              // title="Tasks:"
              headerColor="primary"
              tabs={[
                
                {
                  tabName: "Buy/Sell",
                  
                  // tabIcon: Dashboard1,
                  tabContent: (                          
                                                          // 1st Tab
                                                        // Buy part
                  <GridContainer xs={12} sm={12} md={12}>

                    <GridItem xs={12} sm={12} md={6}> 

                    
                      <Card style={{backgroundColor:"#f4f9fb"}}>
                        <CardHeader id="popularheader" color="primary">
                          <h4 className={classes.cardTitleWhite}>Buy</h4>
                          <GridItem style={{float:"right", marginTop:"-40px"}}>

                          <a href="#" >
                            <p className={classes.cardCategoryWhite}>
                              <CreditCard style={{marginTop:"10px", marginRight:"10px"}}/>
                              0.00000000 BTC
                              <Tooltip placement="top" 
                              title="Total:5 BTC " 
                              arrow >
                                <ContactSupport style={{ marginLeft:"10px"}}/>
                              </Tooltip>  
                            </p>
                          </a>

                          </GridItem>
                        </CardHeader>
                        <CardBody>
                          
                          <GridContainer style={{backgroundColor:"",borderRadius:"10px", borderBottom:"0.2px solid gray"}}>
                            <GridItem  xs={12} sm={12} md={12} >
                              
                              <GridItem >
                                <p id="buyselltext">Units</p>
                                <Input style={{width:"90%"}} id="buysellinput"  placeholder="MATIC"  type="text">105043</Input>
                                <Input style={{width:"10%"}} disabled placeholder="MATIC"/>
                                <p id="error"></p>
                              </GridItem>
                              
                              <GridContainer style={{paddingLeft:"18px"}} md={12} sm={12} xs={12}>
                                <Card xs={10} sm={10}>
                                  <ToggleButtons color="primary"/>
                                </Card>
                                {/* <GridItem md={6}  sm={6}  xs={6}>
                                  <Card>
                                    <Button style={{marginRight:"-15px"}} color="gray">Limit</Button>
                                  </Card>
                                </GridItem>

                                <GridItem md={6}  sm={6}  xs={6}>
                                  <Card>
                                    <Button style={{marginLeft:"-13px"}} color="info">Martket</Button>
                                  </Card>
                                </GridItem> */}

                              </GridContainer>

                                <GridItem >
                                  <p id="buyselltext">Price</p>
                                  <Input style={{width:"90%"}} id="buysellinput"  placeholder="MATIC"  type="text">0.00000238</Input>
                                  <Input style={{width:"10%"}} disabled placeholder="BTC"/>
                                  <p id="error"></p>
                                </GridItem>
                                <GridItem >
                                  <p id="buyselltext">Total</p>
                                  <Input style={{width:"90%"}} id="buysellinput"  placeholder="MATIC"  type="text"/>
                                  <Input style={{width:"10%"}} disabled placeholder="BTC"/>
                                </GridItem>
                                <GridItem md={12} sm={12} xs={12} id="buysellgroupbottoms">
                                  <ButtonGroup md={12} sm={12} xs={12}  color="primary">
                                    <ToggleButtonPrecent/>
                                  </ButtonGroup>
                                </GridItem>
                            </GridItem>
                        
                            {/* <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                              <p id="populartext"  className={classes.cardCategory}>
                                <span className={classes.successText}>
                                <ArrowUpward className={classes.upArrowCardCategory} /> 2.98%+
                                </span>{" "}
                              </p>
                              <p id="populartext">17</p>
                              <p id="populartext">6</p>
                              <p style={{color:"red"}} id="populartext">No</p>
                              <p id="populartext">11/16/2020</p>
                            </GridItem> */}
                          </GridContainer>
            
                          <Card>
                            <Button type="button" color="info">Connect An Exchange</Button>
                          </Card>
                        </CardBody>
                      </Card>
                    </GridItem>
                                                        {/* Sell Part */}
                    <GridItem  xs={12} sm={12} md={6}> 
                      <Card style={{backgroundColor:"#f4f9fb"}}>
                        <CardHeader id="popularheader" color="primary">
                          <h4 className={classes.cardTitleWhite}>Sell</h4>
                          <GridItem style={{float:"right", marginTop:"-40px"}}>

                          <a href="#" >
                            <p  className={classes.cardCategoryWhite}>
                              <CreditCard style={{marginTop:"10px", marginRight:"10px"}}/>
                              0.00000000 MATIC
                              <Tooltip placement="top" 
                              title="Total:0 MATIC " 
                              arrow >
                                <ContactSupport style={{ marginLeft:"10px"}}/>
                              </Tooltip>  
                            </p>
                          </a>

                          </GridItem>
                        </CardHeader>
                        <CardBody>
                          
                          <GridContainer style={{backgroundColor:"",borderRadius:"10px", borderBottom:"0.2px solid gray"}}>
                            <GridItem  xs={12} sm={12} md={12} >
                              
                              <GridItem >
                                <p id="buyselltext">Units</p>
                                <Input style={{width:"90%"}} id="buysellinput"  placeholder="MATIC"  type="text">105043</Input>
                                <Input style={{width:"10%"}} disabled placeholder="MATIC"/>
                                <p id="error"></p>
                              </GridItem>
                              
                              <GridContainer style={{paddingLeft:"18px"}} md={12} sm={12} xs={12}>
                                <Card xs={10} sm={10}>
                                  <ToggleButtons color="primary"/>
                                </Card>
                                {/* <GridItem md={6}  sm={6}  xs={6}>
                                  <Card>
                                    <Button style={{marginRight:"-15px"}} color="gray">Limit</Button>
                                  </Card>
                                </GridItem>

                                <GridItem md={6}  sm={6}  xs={6}>
                                  <Card>
                                    <Button style={{marginLeft:"-13px"}} color="info">Martket</Button>
                                  </Card>
                                </GridItem> */}

                              </GridContainer>

                                <GridItem >
                                  <p id="buyselltext">Price</p>
                                  <Input style={{width:"90%"}} id="buysellinput"  placeholder="MATIC"  type="text">0.00000238</Input>
                                  <Input style={{width:"10%"}} disabled placeholder="BTC"/>
                                </GridItem>
                                <GridItem >
                                  <p id="buyselltext">Total</p>
                                  <Input style={{width:"90%"}} id="buysellinput"  placeholder="MATIC"  type="text"/>
                                  <Input style={{width:"10%"}} disabled placeholder="BTC"/>
                                  <p id="error"></p>
                                </GridItem>
                                <GridItem md={12} sm={12} xs={12} id="buysellgroupbottoms">
                                  <ToggleButtonPrecent/>
                                </GridItem>
                            </GridItem>
                        
                            {/* <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                              <p id="populartext"  className={classes.cardCategory}>
                                <span className={classes.successText}>
                                <ArrowUpward className={classes.upArrowCardCategory} /> 2.98%+
                                </span>{" "}
                              </p>
                              <p id="populartext">17</p>
                              <p id="populartext">6</p>
                              <p style={{color:"red"}} id="populartext">No</p>
                              <p id="populartext">11/16/2020</p>
                            </GridItem> */}
                          </GridContainer>
            
                          <Card>
                            <Button type="button" color="info">Connect An Exchange</Button>
                          </Card>
                        </CardBody>
                      </Card>
                    </GridItem>
                              


                  </GridContainer>
          

                            
          
                    
                    // <Tasks
                    //   checkedIndexes={[0, 3]}
                    //   tasksIndexes={[0, 1, 2, 3]}
                    //   tasks={bugs}
                    // />
                  )
                },                               
                                                // 2nd Tab
                                              // Smart Trade Tab
                {
                  tabName: "Smart Trade",
                  // tabIcon: LockIcon,
                  tabContent: (

                    <GridContainer md={12} sm={12} xs={12}>

                      <GridItem  md={4} sm={12} xs={12}>
                        
                      
                        <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 >Units</h5>

                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-48px", float:"right", marginRight:"-35px"}}>

                                <a href="#" >
                                  <p style={{fontSize:"13px"}} className={classes.cardCategoryWhite}>
                                    <CreditCard style={{marginTop:"10px",width:"20px"}}/>
                                    5.00000000 BTC
                                    <Tooltip placement="top" 
                                    title="Total:5 BTC " 
                                    arrow >
                                      <ContactSupport style={{ width:"20px"}}/>
                                    </Tooltip>  
                                  </p>
                                </a>

                              </GridItem>
                            </CardHeader>

                            <CardBody>
                             <GridItem >
                                {/* <p id="buyselltext">Units</p> */}
                                <Input style={{width:"80%"}} id="buysellinput"  placeholder="MATIC"  type="text">105043</Input>
                                <Input style={{width:"15%"}} disabled placeholder="MATIC"/>
                                <p id="error"></p>
                              </GridItem>
                            </CardBody>

                            {/* <CardFooter stats>
                              <div className={classes.stats}>
                                <DateRange /> 
                                Last 24 Hours
                              </div>
                            </CardFooter> */}
                        </GridItem>

                        <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Price</h5>
                            </CardHeader>

                            <CardBody> 
                              <ToggleButtonThreeB/>
                              <p style={{textAlign:"center"}}>Will be placed on the exchange order book.
                               Can’t buy higher than the current price</p>
                            </CardBody> 

                            <CardBody>
                             <GridItem style={{marginTop:"-25px", textAlign:"center"}}>
                                {/* <p id="buyselltext">Units</p> */}
                                <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                                <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                                <p style={{color:"green"}} id="error">Bid:<a href="#">00000380 BTC</a> Ask:<a href="#">00000570 BTC</a></p>
                              </GridItem>

                              

                              <GridContainer>

                                <GridItem >
                                  <p>Trailing buy</p>
                                </GridItem>

                                <GridItem style={{marginLeft:"-30px"}}>
                                <Tooltip placement="top" 
                                    title="Gets activated after reaching the set price. It starts to follow the price after activation. Will follow the price movements down when used with Smart Trade.
                                     Will follow movements up when used with Smart Cover. The Trailing level will always remain at the set deviation from the price. When the price crosses this level,
                                      it triggers the buy action for Smart Trade, and for Smart Cover it triggers the sell action.  " 
                                    arrow >
                                      <ContactSupport style={{ width:"20px"}}/>
                                    </Tooltip>  
                                </GridItem>
                                
                                <GridItem id="tabboxswitch">
                                  <Switch/>
                                </GridItem>
                                <GridContainer>
                                  <GridItem md={5} sm={5} xs={5}>
                                    <Input type="number"><Input placeholder="type here"/></Input>
                                  </GridItem>
                                  <GridItem id="inputdisablethings" md={2} sm={2} xs={2}>
                                    <Input value="%" disabled/>  
                                  </GridItem>
                                </GridContainer>
                              </GridContainer>

                            </CardBody>

                            {/* <CardFooter stats>
                              <div className={classes.stats}>
                                <DateRange /> 
                                Last 24 Hours
                              </div>
                            </CardFooter> */}
                        </GridItem>

                        <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Total</h5>
                            </CardHeader>

                            <CardBody>
                              <GridItem style={{marginTop:"-5px"}}>
                                {/* <p id="buyselltext">Units</p> */}
                                <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                                <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                                
                              </GridItem>
                                <p id="error">Size from available amount</p>
                                <ToggleButtonPrecentSmall/>
                            </CardBody>
                            
                            {/* <CardFooter stats>
                              <div className={classes.stats}>
                                <DateRange /> 
                                Last 24 Hours
                              </div>
                            </CardFooter> */}
                        </GridItem>
                        
 
                      </GridItem>
                      
                        

                      <GridItem md={4} sm={12} xs={12}>
                        
                      <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Take Profits</h5>

                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                                <Switch/>
                              </GridItem>
                            </CardHeader>
                          
                          <GridItem style={{marginTop:"20px"}}>
                            <ToggleButtonSmall/>
                            <p>Will be placed on the exchange order book beforehand</p>
                          </GridItem>
                          
                          <GridItem>
                            <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                            <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                          </GridItem>

                        <GridContainer id="takeprofitbox">
                          <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                            <Slider />
                          </GridItem>

                          <GridItem md={3} sm={3} xs={3}>
                            <Input type="number"><Input placeholder="%"/></Input>
                          </GridItem>
                        </GridContainer>

                        <Card id="splittargetbutton">
                          <Button>Split Targets</Button>
                        </Card>

                        <GridContainer>

                          <GridItem >
                            <p>Trailing Take Profit</p>
                          </GridItem>

                          <GridItem style={{marginLeft:"-30px"}}>
                            <Tooltip placement="top" 
                                title="Gets activated after reaching the set profit level. It starts to follow the price after activation.
                                 Will follow the price movements up when used with Smart Trade and Smart Sell. 
                                 Will follow movements down when used with Smart Cover. 
                                 The Trailing Take Profit level will always remain at the set deviation from the price.
                                  When the price crosses this level, it triggers the sell action for Smart Trade and Smart Sell,
                                   for Smart Cover it triggers the buy action.  " 
                                  arrow >
                              <ContactSupport style={{ width:"20px"}}/>
                            </Tooltip>  
                          </GridItem>
                          
                          <GridItem id="tabboxswitch">
                            <Switch/>
                            
                          </GridItem>

                          <CardBody id="tabboxtext">
                            <p>Follow max price with deviation (%)</p>
                          </CardBody>

                        </GridContainer>

                        <GridContainer id="takeprofitbox">
                          <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                            <Slider />
                          </GridItem>

                          <GridItem md={3} sm={3} xs={3}>
                            <Input type="number"><Input placeholder="%s"/></Input>
                          </GridItem>
                        </GridContainer>



                        </GridItem>
                      </GridItem>

                      <GridItem md={4} sm={12} xs={12}>
                        
                      <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                            
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Stop Loss</h5>

                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                                <Switch/>
                              </GridItem>
                            </CardHeader>
                          
                          <GridItem style={{marginTop:"20px"}}>
                            <ToggleButtonSmall/>
                            <p>Will be placed on the exchange order book beforehand</p>
                          </GridItem>
                          
                          <GridItem>
                            <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                            <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                          </GridItem>

                        <GridContainer id="takeprofitbox">
                          <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                            <Slider />
                          </GridItem>

                          <GridItem md={3} sm={3} xs={3}>
                            <Input type="number"><Input placeholder="%"/></Input>
                          </GridItem>
                        </GridContainer>


                        <GridContainer style={{paddingBottom:"-10px"}}>

                          <GridItem >
                            <p>Stop Loss Timeout</p>
                          </GridItem>

                          <GridItem style={{marginLeft:"-30px"}}>
                            <Tooltip placement="top" 
                                title="A double check before triggering the Stop Loss. The system will check conditions when the price reaches them, 
                                and additionally after the set amount of seconds passes.
                                 If Stop Loss condition is not true after the delay, it won’t trigger. 
                                 A high delay might incur higher losses  " 
                                  arrow >
                              <ContactSupport style={{ width:"20px"}}/>
                            </Tooltip>  
                          </GridItem>
                          
                          <GridItem id="tabboxswitch">
                            <Switch/>
                          </GridItem>
                          
                        </GridContainer>
                        
                        <GridContainer>
                          <GridItem md={5} sm={5} xs={5}>
                            <Input type="number"><Input placeholder="type here"/></Input>
                          </GridItem>
                          <GridItem id="inputdisablethings" md={2} sm={2} xs={2}>
                            <Input value="Sec" disabled/>  
                          </GridItem>
                        </GridContainer>

                          <GridContainer style={{paddingTop:"10px"}}>

                            <GridItem id="switchtrailingstop" >
                              <p>Trailing Stop Profit</p>
                            </GridItem>

                            <GridItem style={{marginLeft:"-30px"}}>
                              <Tooltip placement="top" 
                                  title="Gets activated after Smart Sell is created, Smart Trade has bought coins, and Smart Cover has sold coins.
                                   Will follow the price movements up when used with Smart Trade and Smart Sell.
                                    Will follow movements down when used with Smart Cover. 
                                    It will be at the same distance from the reached price. " 
                                    arrow >
                                <ContactSupport style={{ width:"20px"}}/>
                              </Tooltip>  
                            </GridItem>

                            <GridItem id="tabboxswitch">
                              <Switch/>
                              
                            </GridItem>

                          </GridContainer>




                        </GridItem>
                      </GridItem>

                      <Card>
                        <Button type="button" color="info">Connect An Exchange</Button>
                      </Card>

                    </GridContainer>
                  )
                },
                                              // 3rd Tab
                                              // Smart Sell   
                {
                  tabName: "Smart Sell",
                  // tabIcon: LibraryBooksIcon,
                  tabContent: (
                    <GridContainer md={12} sm={12} xs={12}>

                    <GridItem  md={4} sm={12} xs={12}>
                      
                    
                      <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Units</h5>

                            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-48px", float:"right", marginRight:"-35px"}}>

                              <a href="#" >
                                <p style={{fontSize:"13px"}} className={classes.cardCategoryWhite}>
                                  <CreditCard style={{marginTop:"10px",width:"20px"}}/>
                                  0.00000000 MATIC
                                  <Tooltip placement="top" 
                                  title="Total:0 MATIC " 
                                  arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </p>
                              </a>

                            </GridItem>
                          </CardHeader>

                          <CardBody>
                           <GridItem >
                              {/* <p id="buyselltext">Units</p> */}
                              <Input style={{width:"80%"}} id="buysellinput"  placeholder="MATIC"  type="text">105043</Input>
                              <Input style={{width:"15%"}} disabled placeholder="MATIC"/>
                              <p id="error"></p>
                            </GridItem>

                            <p id="error">Size from available amount</p>
                            <ToggleButtonPrecentSmall/>
                          </CardBody>

                          {/* <CardFooter stats>
                            <div className={classes.stats}>
                              <DateRange /> 
                              Last 24 Hours
                            </div>
                          </CardFooter> */}
                      </GridItem>

                      <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Bought Price</h5>
                          </CardHeader>

                          <CardBody> 
                            {/* <ToggleButtonThreeB/>
                            <p style={{textAlign:"center"}}>Will be placed on the exchange order book.
                             Can’t buy higher than the current price</p> */}
                          </CardBody> 

                          <CardBody>
                           <GridItem style={{marginTop:"-25px", textAlign:"center"}}>
                              {/* <p id="buyselltext">Units</p> */}
                              <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                              <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                              <p style={{color:"green"}} id="error">Corrent Price:<a href="#">0.00000446 BTC</a></p>
                            </GridItem>

                            

                            {/* <GridContainer>

                              <GridItem >
                                <p>Trailing buy</p>
                              </GridItem>

                              <GridItem style={{marginLeft:"-30px"}}>
                              <Tooltip placement="top" 
                                  title="Gets activated after reaching the set price. It starts to follow the price after activation. Will follow the price movements down when used with Smart Trade.
                                   Will follow movements up when used with Smart Cover. The Trailing level will always remain at the set deviation from the price. When the price crosses this level,
                                    it triggers the buy action for Smart Trade, and for Smart Cover it triggers the sell action.  " 
                                  arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                              </GridItem>
                              
                              <GridItem id="tabboxswitch">
                                <Switch/>
                              </GridItem>

                            </GridContainer> */}

                          </CardBody>

                          {/* <CardFooter stats>
                            <div className={classes.stats}>
                              <DateRange /> 
                              Last 24 Hours
                            </div>
                          </CardFooter> */}
                      </GridItem>

                      <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Total</h5>
                          </CardHeader>

                          <CardBody>
                            <GridItem style={{marginTop:"-5px"}}>
                              {/* <p id="buyselltext">Units</p> */}
                              <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                              <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                            </GridItem>
                              {/* <p id="error">Size from available amount</p>
                              <ToggleButtonPrecentSmall/> */}
                          </CardBody>
                              
                          
                          {/* <CardFooter stats>
                            <div className={classes.stats}>
                              <DateRange /> 
                              Last 24 Hours
                            </div>
                          </CardFooter> */}
                      </GridItem>
                      

                    </GridItem>
                    
                      

                    <GridItem md={4} sm={12} xs={12}>
                      
                    <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Take Profits</h5>

                            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                              <Switch/>
                            </GridItem>
                          </CardHeader>
                        
                        <GridItem style={{marginTop:"20px"}}>
                          <ToggleButtonSmall/>
                          <p>Will be placed on the exchange order book beforehand</p>
                        </GridItem>
                        
                        <GridItem>
                          <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                          <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                        </GridItem>

                      <GridContainer id="takeprofitbox">
                        <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                          <Slider />
                        </GridItem>

                        <GridItem md={3} sm={3} xs={3}>
                          <Input type="number"><Input placeholder="%"/></Input>
                        </GridItem>
                      </GridContainer>

                      <Card id="splittargetbutton">
                        <Button>Split Targets</Button>
                      </Card>

                      <GridContainer>

                        <GridItem >
                          <p>Trailing Take Profit</p>
                        </GridItem>

                        <GridItem style={{marginLeft:"-30px"}}>
                          <Tooltip placement="top" 
                              title="Gets activated after reaching the set profit level. It starts to follow the price after activation.
                               Will follow the price movements up when used with Smart Trade and Smart Sell. 
                               Will follow movements down when used with Smart Cover. 
                               The Trailing Take Profit level will always remain at the set deviation from the price.
                                When the price crosses this level, it triggers the sell action for Smart Trade and Smart Sell,
                                 for Smart Cover it triggers the buy action.  " 
                                arrow >
                            <ContactSupport style={{ width:"20px"}}/>
                          </Tooltip>  
                        </GridItem>
                        
                        <GridItem id="tabboxswitch">
                          <Switch/>
                          
                        </GridItem>

                        <CardBody id="tabboxtext">
                          <p>Follow max price with deviation (%)</p>
                        </CardBody>

                      </GridContainer>

                      <GridContainer id="takeprofitbox">
                        <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                          <Slider />
                        </GridItem>

                        <GridItem md={3} sm={3} xs={3}>
                          <Input type="number"><Input placeholder="%s"/></Input>
                        </GridItem>
                      </GridContainer>



                      </GridItem>
                    </GridItem>

                    <GridItem md={4} sm={12} xs={12}>
                      
                    <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                          
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Stop Loss</h5>

                            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                              <Switch/>
                            </GridItem>
                          </CardHeader>
                        
                        <GridItem style={{marginTop:"20px"}}>
                          <ToggleButtonSmall/>
                          <p>Will be placed on the exchange order book beforehand</p>
                        </GridItem>
                        
                        <GridItem>
                          <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                          <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                        </GridItem>

                      <GridContainer id="takeprofitbox">
                        <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                          <Slider />
                        </GridItem>

                        <GridItem md={3} sm={3} xs={3}>
                          <Input type="number"><Input placeholder="%"/></Input>
                        </GridItem>
                      </GridContainer>


                      <GridContainer style={{paddingBottom:"-10px"}}>

                        <GridItem >
                          <p>Stop Loss Timeout</p>
                        </GridItem>

                        <GridItem style={{marginLeft:"-30px"}}>
                          <Tooltip placement="top" 
                              title="A double check before triggering the Stop Loss. The system will check conditions when the price reaches them, 
                              and additionally after the set amount of seconds passes.
                               If Stop Loss condition is not true after the delay, it won’t trigger. 
                               A high delay might incur higher losses  " 
                                arrow >
                            <ContactSupport style={{ width:"20px"}}/>
                          </Tooltip>  
                        </GridItem>
                        
                        <GridItem id="tabboxswitch">
                          <Switch/>
                        </GridItem>
                        
                      </GridContainer>
                      
                      <GridContainer>
                        <GridItem md={5} sm={5} xs={5}>
                          <Input type="number"><Input placeholder="type here"/></Input>
                        </GridItem>
                        <GridItem id="inputdisablethings" md={2} sm={2} xs={2}>
                          <Input value="Sec" disabled/>  
                        </GridItem>
                      </GridContainer>

                        <GridContainer style={{paddingTop:"10px"}}>

                          <GridItem id="switchtrailingstop" >
                            <p>Trailing Stop Profit</p>
                          </GridItem>

                          <GridItem style={{marginLeft:"-30px"}}>
                            <Tooltip placement="top" 
                                title="Gets activated after Smart Sell is created, Smart Trade has bought coins, and Smart Cover has sold coins.
                                 Will follow the price movements up when used with Smart Trade and Smart Sell.
                                  Will follow movements down when used with Smart Cover. 
                                  It will be at the same distance from the reached price. " 
                                  arrow >
                              <ContactSupport style={{ width:"20px"}}/>
                            </Tooltip>  
                          </GridItem>

                          <GridItem id="tabboxswitch">
                            <Switch/>
                            
                          </GridItem>

                        </GridContainer>




                      </GridItem>
                    </GridItem>

                    <Card>
                      <Button type="button" color="info">Connect An Exchange</Button>
                    </Card>

                  </GridContainer>
                
                  )
                },
                                                  // 4th tab
                                                //  Smart Cover Tab
                {
                  tabName: "Smart Cover",
                  // tabIcon: LockIcon,
                  tabContent: (
                    <GridContainer md={12} sm={12} xs={12}>

                      <GridItem  md={4} sm={12} xs={12}>
                        
                      
                        <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Units</h5>

                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-48px", float:"right", marginRight:"-35px"}}>

                                <a href="#" >
                                  <p style={{fontSize:"13px"}} className={classes.cardCategoryWhite}>
                                    <CreditCard style={{marginTop:"10px",width:"20px"}}/>
                                    5.00000000 BTC
                                    <Tooltip placement="top" 
                                    title="Total:5 BTC " 
                                    arrow >
                                      <ContactSupport style={{ width:"20px"}}/>
                                    </Tooltip>  
                                  </p>
                                </a>

                              </GridItem>
                            </CardHeader>

                            <CardBody>
                             <GridItem >
                                {/* <p id="buyselltext">Units</p> */}
                                <Input style={{width:"80%"}} id="buysellinput"  placeholder="MATIC"  type="text">105043</Input>
                                <Input style={{width:"15%"}} disabled placeholder="MATIC"/>
                                <p id="error"></p>
                              </GridItem>
                            </CardBody>

                            {/* <CardFooter stats>
                              <div className={classes.stats}>
                                <DateRange /> 
                                Last 24 Hours
                              </div>
                            </CardFooter> */}
                        </GridItem>

                        <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Sell Price</h5>
                            </CardHeader>

                            <CardBody> 
                              <ToggleButtonThreeB/>
                              <p style={{textAlign:"center"}}>Will be placed on the exchange order book.
                               Can’t buy higher than the current price</p>
                            </CardBody> 

                            <CardBody>
                             <GridItem style={{marginTop:"-25px", textAlign:"center"}}>
                                {/* <p id="buyselltext">Units</p> */}
                                <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                                <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                                <p style={{color:"green"}} id="error">Bid:<a href="#">00000380 BTC</a> Ask:<a href="#">00000570 BTC</a></p>
                              </GridItem>

                              

                              <GridContainer>

                                <GridItem >
                                  <p>Trailing buy</p>
                                </GridItem>

                                <GridItem style={{marginLeft:"-30px"}}>
                                <Tooltip placement="top" 
                                    title="Gets activated after reaching the set price. It starts to follow the price after activation. Will follow the price movements down when used with Smart Trade.
                                     Will follow movements up when used with Smart Cover. The Trailing level will always remain at the set deviation from the price. When the price crosses this level,
                                      it triggers the buy action for Smart Trade, and for Smart Cover it triggers the sell action.  " 
                                    arrow >
                                      <ContactSupport style={{ width:"20px"}}/>
                                    </Tooltip>  
                                </GridItem>
                                
                                <GridItem id="tabboxswitch">
                                  <Switch/>
                                </GridItem>

                                <GridContainer>
                                  <GridItem md={5} sm={5} xs={5}>
                                    <Input type="number"><Input placeholder="type here"/></Input>
                                  </GridItem>
                                  <GridItem id="inputdisablethings" md={2} sm={2} xs={2}>
                                    <Input value="%" disabled/>  
                                  </GridItem>
                                </GridContainer>
                              </GridContainer>

                            </CardBody>

                            {/* <CardFooter stats>
                              <div className={classes.stats}>
                                <DateRange /> 
                                Last 24 Hours
                              </div>
                            </CardFooter> */}
                        </GridItem>

                        <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Total</h5>
                            </CardHeader>

                            <CardBody>
                              <GridItem style={{marginTop:"-5px"}}>
                                {/* <p id="buyselltext">Units</p> */}
                                <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                                <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                                
                              </GridItem>
                                <p id="error">Size from available amount</p>
                                <ToggleButtonPrecentSmall/>
                            </CardBody>
                            
                            {/* <CardFooter stats>
                              <div className={classes.stats}>
                                <DateRange /> 
                                Last 24 Hours
                              </div>
                            </CardFooter> */}
                        </GridItem>
                        
 
                      </GridItem>
                      
                        

                      <GridItem md={4} sm={12} xs={12}>
                        
                      <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Take Profits</h5>

                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                                <Switch/>
                              </GridItem>
                            </CardHeader>
                          
                          <GridItem style={{marginTop:"20px"}}>
                            <ToggleButtonSmall/>
                            <p>Will be placed on the exchange order book beforehand</p>
                          </GridItem>
                          
                          <GridItem>
                            <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                            <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                          </GridItem>

                        <GridContainer id="takeprofitbox">
                          <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                            <Slider />
                          </GridItem>

                          <GridItem md={3} sm={3} xs={3}>
                            <Input type="number"><Input placeholder="%"/></Input>
                          </GridItem>
                        </GridContainer>

                        <Card id="splittargetbutton">
                          <Button>Split Targets</Button>
                        </Card>

                        <GridContainer>

                          <GridItem >
                            <p>Trailing Take Profit</p>
                          </GridItem>

                          <GridItem style={{marginLeft:"-30px"}}>
                            <Tooltip placement="top" 
                                title="Gets activated after reaching the set profit level. It starts to follow the price after activation.
                                 Will follow the price movements up when used with Smart Trade and Smart Sell. 
                                 Will follow movements down when used with Smart Cover. 
                                 The Trailing Take Profit level will always remain at the set deviation from the price.
                                  When the price crosses this level, it triggers the sell action for Smart Trade and Smart Sell,
                                   for Smart Cover it triggers the buy action.  " 
                                  arrow >
                              <ContactSupport style={{ width:"20px"}}/>
                            </Tooltip>  
                          </GridItem>
                          
                          <GridItem id="tabboxswitch">
                            <Switch/>
                            
                          </GridItem>

                          <CardBody id="tabboxtext">
                            <p>Follow max price with deviation (%)</p>
                          </CardBody>

                        </GridContainer>

                        <GridContainer id="takeprofitbox">
                          <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                            <Slider />
                          </GridItem>

                          <GridItem md={3} sm={3} xs={3}>
                            <Input type="number"><Input placeholder="%s"/></Input>
                          </GridItem>
                        </GridContainer>



                        </GridItem>
                      </GridItem>

                      <GridItem md={4} sm={12} xs={12}>
                        
                      <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                            
                            <CardHeader color="primary" stats >
                              
                              <h5 className={classes.cardTitle}>Stop Loss</h5>

                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                                <Switch/>
                              </GridItem>
                            </CardHeader>
                          
                          <GridItem style={{marginTop:"20px"}}>
                            <ToggleButtonSmall/>
                            <p>Will be placed on the exchange order book beforehand</p>
                          </GridItem>
                          
                          <GridItem>
                            <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                            <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                          </GridItem>

                        <GridContainer id="takeprofitbox">
                          <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                            <Slider />
                          </GridItem>

                          <GridItem md={3} sm={3} xs={3}>
                            <Input type="number"><Input placeholder="%"/></Input>
                          </GridItem>
                        </GridContainer>


                        <GridContainer style={{paddingBottom:"-10px"}}>

                          <GridItem >
                            <p>Stop Loss Timeout</p>
                          </GridItem>

                          <GridItem style={{marginLeft:"-30px"}}>
                            <Tooltip placement="top" 
                                title="A double check before triggering the Stop Loss. The system will check conditions when the price reaches them, 
                                and additionally after the set amount of seconds passes.
                                 If Stop Loss condition is not true after the delay, it won’t trigger. 
                                 A high delay might incur higher losses  " 
                                  arrow >
                              <ContactSupport style={{ width:"20px"}}/>
                            </Tooltip>  
                          </GridItem>
                          
                          <GridItem id="tabboxswitch">
                            <Switch/>
                          </GridItem>
                          
                        </GridContainer>
                        
                        <GridContainer>
                          <GridItem md={5} sm={5} xs={5}>
                            <Input type="number"><Input placeholder="type here"/></Input>
                          </GridItem>
                          <GridItem id="inputdisablethings" md={2} sm={2} xs={2}>
                            <Input value="Sec" disabled/>  
                          </GridItem>
                        </GridContainer>

                          <GridContainer style={{paddingTop:"10px"}}>

                            <GridItem id="switchtrailingstop" >
                              <p>Trailing Stop Profit</p>
                            </GridItem>

                            <GridItem style={{marginLeft:"-30px"}}>
                              <Tooltip placement="top" 
                                  title="Gets activated after Smart Sell is created, Smart Trade has bought coins, and Smart Cover has sold coins.
                                   Will follow the price movements up when used with Smart Trade and Smart Sell.
                                    Will follow movements down when used with Smart Cover. 
                                    It will be at the same distance from the reached price. " 
                                    arrow >
                                <ContactSupport style={{ width:"20px"}}/>
                              </Tooltip>  
                            </GridItem>

                            <GridItem id="tabboxswitch">
                              <Switch/>
                              
                            </GridItem>

                          </GridContainer>




                        </GridItem>
                      </GridItem>

                      <Card>
                        <Button type="button" color="info">Connect An Exchange</Button>
                      </Card>

                    </GridContainer>
                  
                  )
                },
                                              // 5th tab
                                              // Smart Buy tab
                {
                  tabName: "Smart Buy",
                  // tabIcon: LockIcon,
                  tabContent: (
                    <GridContainer md={12} sm={12} xs={12}>

                    <GridItem  md={4} sm={12} xs={12}>
                      
                    
                      <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Units</h5>

                            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-48px", float:"right", marginRight:"-35px"}}>

                              <a href="#" >
                                <p style={{fontSize:"13px"}} className={classes.cardCategoryWhite}>
                                  <CreditCard style={{marginTop:"10px",width:"20px"}}/>
                                  0.00000000 MATIC
                                  <Tooltip placement="top" 
                                  title="Total:0 MATIC " 
                                  arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </p>
                              </a>

                            </GridItem>
                          </CardHeader>

                          <CardBody>
                           <GridItem >
                              {/* <p id="buyselltext">Units</p> */}
                              <Input style={{width:"80%"}} id="buysellinput"  placeholder="MATIC"  type="text">105043</Input>
                              <Input style={{width:"15%"}} disabled placeholder="MATIC"/>
                              <p id="error"></p>
                            </GridItem>

                            <p id="error">Size from available amount</p>
                            <ToggleButtonPrecentSmall/>
                          </CardBody>

                          {/* <CardFooter stats>
                            <div className={classes.stats}>
                              <DateRange /> 
                              Last 24 Hours
                            </div>
                          </CardFooter> */}
                      </GridItem>

                      <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Sell Price</h5>
                          </CardHeader>

                          <CardBody> 
                            {/* <ToggleButtonThreeB/>
                            <p style={{textAlign:"center"}}>Will be placed on the exchange order book.
                             Can’t buy higher than the current price</p> */}
                          </CardBody> 

                          <CardBody>
                           <GridItem style={{marginTop:"-25px", textAlign:"center"}}>
                              {/* <p id="buyselltext">Units</p> */}
                              <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                              <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                              <p style={{color:"green"}} id="error">Corrent Price:<a href="#">0.00000446 BTC</a></p>
                            </GridItem>

                            

                            {/* <GridContainer>

                              <GridItem >
                                <p>Trailing buy</p>
                              </GridItem>

                              <GridItem style={{marginLeft:"-30px"}}>
                              <Tooltip placement="top" 
                                  title="Gets activated after reaching the set price. It starts to follow the price after activation. Will follow the price movements down when used with Smart Trade.
                                   Will follow movements up when used with Smart Cover. The Trailing level will always remain at the set deviation from the price. When the price crosses this level,
                                    it triggers the buy action for Smart Trade, and for Smart Cover it triggers the sell action.  " 
                                  arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                              </GridItem>
                              
                              <GridItem id="tabboxswitch">
                                <Switch/>
                              </GridItem>

                            </GridContainer> */}

                          </CardBody>

                          {/* <CardFooter stats>
                            <div className={classes.stats}>
                              <DateRange /> 
                              Last 24 Hours
                            </div>
                          </CardFooter> */}
                      </GridItem>

                      <GridItem id="smarttradetabfirstpart1" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Total</h5>
                          </CardHeader>

                          <CardBody>
                            <GridItem style={{marginTop:"-5px"}}>
                              {/* <p id="buyselltext">Units</p> */}
                              <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                              <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                            </GridItem>
                              {/* <p id="error">Size from available amount</p>
                              <ToggleButtonPrecentSmall/> */}
                          </CardBody>
                              
                          
                          {/* <CardFooter stats>
                            <div className={classes.stats}>
                              <DateRange /> 
                              Last 24 Hours
                            </div>
                          </CardFooter> */}
                      </GridItem>
                      

                    </GridItem>
                    
                      

                    <GridItem md={4} sm={12} xs={12}>
                      
                    <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Take Profits</h5>

                            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                              <Switch/>
                            </GridItem>
                          </CardHeader>
                        
                        <GridItem style={{marginTop:"20px"}}>
                          <ToggleButtonSmall/>
                          <p>Will be placed on the exchange order book beforehand</p>
                        </GridItem>
                        
                        <GridItem>
                          <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                          <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                        </GridItem>

                      <GridContainer id="takeprofitbox">
                        <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                          <Slider />
                        </GridItem>

                        <GridItem md={3} sm={3} xs={3}>
                          <Input type="number"><Input placeholder="%"/></Input>
                        </GridItem>
                      </GridContainer>

                      <Card id="splittargetbutton">
                        <Button>Split Targets</Button>
                      </Card>

                      <GridContainer>

                        <GridItem >
                          <p>Trailing Take Profit</p>
                        </GridItem>

                        <GridItem style={{marginLeft:"-30px"}}>
                          <Tooltip placement="top" 
                              title="Gets activated after reaching the set profit level. It starts to follow the price after activation.
                               Will follow the price movements up when used with Smart Trade and Smart Sell. 
                               Will follow movements down when used with Smart Cover. 
                               The Trailing Take Profit level will always remain at the set deviation from the price.
                                When the price crosses this level, it triggers the sell action for Smart Trade and Smart Sell,
                                 for Smart Cover it triggers the buy action.  " 
                                arrow >
                            <ContactSupport style={{ width:"20px"}}/>
                          </Tooltip>  
                        </GridItem>
                        
                        <GridItem id="tabboxswitch">
                          <Switch/>
                          
                        </GridItem>

                        <CardBody id="tabboxtext">
                          <p>Follow max price with deviation (%)</p>
                        </CardBody>

                      </GridContainer>

                      <GridContainer id="takeprofitbox">
                        <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                          <Slider />
                        </GridItem>

                        <GridItem md={3} sm={3} xs={3}>
                          <Input type="number"><Input placeholder="%s"/></Input>
                        </GridItem>
                      </GridContainer>



                      </GridItem>
                    </GridItem>

                    <GridItem md={4} sm={12} xs={12}>
                      
                    <GridItem id="smarttradetab2nd3rdpart" md={12} sm={12} xs={12}> 
                          
                          <CardHeader color="primary" stats >
                            
                            <h5 className={classes.cardTitle}>Stop Loss</h5>

                            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                              <Switch/>
                            </GridItem>
                          </CardHeader>
                        
                        <GridItem style={{marginTop:"20px"}}>
                          <ToggleButtonSmall/>
                          <p>Will be placed on the exchange order book beforehand</p>
                        </GridItem>
                        
                        <GridItem>
                          <Input style={{width:"80%"}} id="buysellinput"  placeholder=""  type="text">105043</Input>
                          <Input style={{width:"15%"}} disabled placeholder="BTC"/>
                        </GridItem>

                      <GridContainer id="takeprofitbox">
                        <GridItem id="takeprofitboxslider" md={9} sm={9} xs={9}>
                          <Slider />
                        </GridItem>

                        <GridItem md={3} sm={3} xs={3}>
                          <Input type="number"><Input placeholder="%"/></Input>
                        </GridItem>
                      </GridContainer>


                      <GridContainer style={{paddingBottom:"-10px"}}>

                        <GridItem >
                          <p>Stop Loss Timeout</p>
                        </GridItem>

                        <GridItem style={{marginLeft:"-30px"}}>
                          <Tooltip placement="top" 
                              title="A double check before triggering the Stop Loss. The system will check conditions when the price reaches them, 
                              and additionally after the set amount of seconds passes.
                               If Stop Loss condition is not true after the delay, it won’t trigger. 
                               A high delay might incur higher losses  " 
                                arrow >
                            <ContactSupport style={{ width:"20px"}}/>
                          </Tooltip>  
                        </GridItem>
                        
                        <GridItem id="tabboxswitch">
                          <Switch/>
                        </GridItem>
                        
                      </GridContainer>
                      
                      <GridContainer>
                        <GridItem md={5} sm={5} xs={5}>
                          <Input type="number"><Input placeholder="type here"/></Input>
                        </GridItem>
                        <GridItem id="inputdisablethings" md={2} sm={2} xs={2}>
                          <Input value="Sec" disabled/>  
                        </GridItem>
                      </GridContainer>

                        <GridContainer style={{paddingTop:"10px"}}>

                          <GridItem id="switchtrailingstop" >
                            <p>Trailing Stop Profit</p>
                          </GridItem>

                          <GridItem style={{marginLeft:"-30px"}}>
                            <Tooltip placement="top" 
                                title="Gets activated after Smart Sell is created, Smart Trade has bought coins, and Smart Cover has sold coins.
                                 Will follow the price movements up when used with Smart Trade and Smart Sell.
                                  Will follow movements down when used with Smart Cover. 
                                  It will be at the same distance from the reached price. " 
                                  arrow >
                              <ContactSupport style={{ width:"20px"}}/>
                            </Tooltip>  
                          </GridItem>

                          <GridItem id="tabboxswitch">
                            <Switch/>
                            
                          </GridItem>

                        </GridContainer>




                      </GridItem>
                    </GridItem>

                    <Card>
                      <Button type="button" color="info">Connect An Exchange</Button>
                    </Card>

                  </GridContainer>
                
                  )
                },
              ]}
            />
          </GridItem>
        </GridContainer>                    



                                        {/* Orders and Positions */}

      
  
                                              {OrdersComponent}




         {/* <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Edit Profile</h4>
              <p className={classes.cardCategoryWhite}>Complete your profile</p>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={5}>
                  <CustomInput
                    labelText="Company (disabled)"
                    id="company-disabled"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Username"
                    id="username"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Email address"
                    id="email-address"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="First Name"
                    id="first-name"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Last Name"
                    id="last-name"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="City"
                    id="city"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Country"
                    id="country"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Postal Code"
                    id="postal-code"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <InputLabel style={{ color: "#AAAAAA" }}>About me</InputLabel>
                  <CustomInput
                    labelText="Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo."
                    id="about-me"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      multiline: true,
                      rows: 5
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button color="primary">Update Profile</Button>
            </CardFooter>
          </Card>
        </GridItem> */}


        {/* <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              
              <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
              <h4 className={classes.cardTitle}>Alec Thompson</h4>
              <p className={classes.description}>
                Don{"'"}t be scared of the truth because we need to restart the
                human foundation in truth And I love you like Kanye loves Kanye
                I love Rick Owens’ bed design but the back is...
              </p>
              <Button color="primary" round>
                Follows
              </Button>
            </CardBody>
          </Card>
        </GridItem> */}

        <GridContainer md={12} sm={12} xs={12} style={{paddingTop:"30px"}}> 
          <GridItem xs={12} sm={12} md={12} style={{marginBottom:"-2.3rem",}}>
            <CustomTabs 
              // title="Tasks:"
              headerColor="primary"
              tabs={[
                
                {
                  tabName: "Active",
                  
                  // tabIcon: Dashboard1,
                  tabContent: (                          
                                                          // 1st Tab
                                                        // Active part
                    <GridContainer md={12} sm={12} xs={12}>
                        <GridItem style={{textAlign:"center"}} md={12} sm={12} xs={12}>
                          <p>No data to display</p>
                        </GridItem>
                    </GridContainer>

                  )
                },                               
                                                // 2nd Tab
                                              // History Tab
                {
                  tabName: "History",
                  // tabIcon: LockIcon,
                  tabContent: (
                    <GridItem id="ordersandpositions" md={12} sm={12} xs={12}>
                      
                      <GridItem  md={12} sm={12} xs={12}> 
                            
                            <CardHeader md={12} sm={12} xs={12} style={{marginLeft:"-19px"}} color="primary" stats>
                              
                              <h4>Filters</h4>

                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-38px", float:"right", marginRight:"-35px"}}>
                                <Button id="filterbutton" size="small" ><LayersClear id="filtericon"/>Clear Filters</Button>
                                <Switch onClick={ToggleHistoryComponent}/>
                              </GridItem>
                            </CardHeader>
                            
                              {HistoryComponent}
                            
                      </GridItem>
                    </GridItem>
                  )
                },
                                              // 3rd Tab
                                              // Smart Sell   
                // {
                //   tabName: "Smart Sell",
                //   // tabIcon: LibraryBooksIcon,
                //   tabContent: (
                    
                //   )
                // },
                                                  // 4th tab
                                                //  Smart Cover Tab
                // {
                //   tabName: "Smart Cover",
                //   // tabIcon: LockIcon,
                //   tabContent: (
                   
                //   )
                // },
                                              // 5th tab
                                              // Smart Buy tab
                // {
                //   tabName: "Smart Buy",
                //   // tabIcon: LockIcon,
                //   tabContent: (
                    
                //   )
                // },
              ]}
            />
          </GridItem>
        </GridContainer>                    



      </GridContainer>
      
    </div>
  );

}
